import React from 'react';
import { Fab, Hidden } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PhoneIcon from '@material-ui/icons/Phone';
import siteConfig from '../siteConfig';

const useStyles = makeStyles((theme) => ({
  fab: {
    // Bottom-right, where it's easiest to reach with a thumb.
    position: 'fixed',
    right: theme.spacing(2),
    bottom: theme.spacing(2),
    zIndex: theme.zIndex.appBar - 1,
    fontWeight: 700,
    boxShadow: '0 8px 24px rgba(14,35,64,0.3)',
  },
  icon: {
    marginRight: theme.spacing(1),
  },
}));

// A floating "Call" button for phones and tablets.
export default function MobileCallButton() {
  const classes = useStyles();

  return (
    <Hidden mdUp implementation="css">
      <Fab
        variant="extended"
        color="secondary"
        href={siteConfig.phoneHref}
        className={classes.fab}
        aria-label={`Call ${siteConfig.phoneDisplay}`}
      >
        <PhoneIcon className={classes.icon} />
        Call now
      </Fab>
    </Hidden>
  );
}
